import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { auth } from "@/lib/api";
import { Lock, User, AlertCircle } from "lucide-react";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await auth.login(username, password);
      login(res.data.token, res.data.username, res.data.role || "admin");
      navigate("/admin/dashboard");
    } catch {
      setError("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/aht_round_orange.png" alt="AHT" style={{ height: 48, width: 48, borderRadius: "50%", marginBottom: 8 }} />
          <h1 className="login-title">Aylesbury Hindu Temple</h1>
          <p className="login-subtitle">Campaign Coordinator Dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error" data-testid="login-error">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}
          <div className="login-field">
            <label>Username</label>
            <div className="login-input-wrap">
              <User size={16} />
              <input
                data-testid="login-username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                autoComplete="username"
              />
            </div>
          </div>
          <div className="login-field">
            <label>Password</label>
            <div className="login-input-wrap">
              <Lock size={16} />
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="current-password"
              />
            </div>
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            className="login-btn"
            disabled={loading || !username || !password}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
